// src/pages/NotFound.jsx
import React from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function NotFound() {
  const { pathname } = useLocation();
  return (
    <div style={{minHeight:'60vh'}} className="d-flex align-items-center justify-content-center text-center p-4">
      <div>
        <h1 className="display-4 fw-bold">404</h1>
        <p className="lead mb-1">We couldn’t find: <code>{pathname}</code></p>
        <p className="text-muted mb-4">The page may have moved or the link is incorrect.</p>
        <Link to="/" className="btn btn-primary">Go to Home</Link>
      </div>
    </div>
  );
}